import fetch from 'isomorphic-fetch'
import { createAction } from 'redux-actions'
import debounce from 'lodash/debounce'

export const SEARCH = 'SEARCH'
export const CLEAR_SEARCH = 'CLEAR_SEARCH'

const querySearchDebounced = debounce((dispatch, topic, query, source, page, getState) => {
  import('algoliasearch')
  .then((algoliasearch) => {
    const index = algoliasearch('VS6NASEWRI', '5b03ea7d9db3fa60d08ef1140d14ae19').initIndex('prod_ARTICLES')
    if (query != getState().search.query) {
      return
    }

    const baseOptions = {
      hitsPerPage: 25,
      page: (page || 1) - 1,
      filters: "date_added>0",
      exactOnSingleWordQuery: "none",
      facets: ["*"]
    }

    index.search(query, { 
      ...baseOptions,
      filters: source ? baseOptions.filters + ' AND source_name:"' + source + '"' : baseOptions.filters
    }, (err, content) => {
      if (err) {
        dispatch(createAction(SEARCH)(err))
        return
      }
      dispatch(createAction(SEARCH)({ isSearching: false, facets: content.facets, results: content.hits, atEnd: content.hits.length === 0 }))      
    })

    // pull all facets if necessary
    if (source) {
      index.search(query, { 
        ...baseOptions
      }, (err, content) => {
        dispatch(createAction(SEARCH)({ facets: content.facets }))      
      })
    }
  })
}, 500)

const fetchDebounced = debounce((dispatch, topic, query, page, getState) => {
  return fetch(`${process.env.REACT_APP_API_HOST}/search${topic ? `/${topic}` : ''}?query=${query || ''}&page=${page || 1}`)
          .then((response) => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response.json()
          })
          .then(json => dispatch(createAction(SEARCH)({ isSearching: false, results: json, atEnd: json.length === 0 })))
          .catch(error => dispatch(createAction(SEARCH)(error)))
}, 500)

export function fetchTopic(topic, query, source, page) {
  return (dispatch, getState) => {
    if (!query && !source) {
      return
    }

    dispatch(createAction(SEARCH)({ isSearching: true, topic, query, source }))
    
    if (topic != 'xbox') {
      querySearchDebounced(dispatch, topic, query, source, page, getState)
      return
    }
    
    fetchDebounced(dispatch, topic, query, page, getState)
  }
}



// WEBPACK FOOTER //
// ./src/actions/search.js